import { gql } from "apollo-boost"

export const UPDATE_SUSTAINABILITY_DETAILS = gql`
   mutation updateSustanabilityDetails($data: CreateSustainabilityDetails!, $id: String!) {
    UpdateSustainabilityDetails(data: $data, id: $id)
  }
`